export default __webpack_public_path__ + "static/media/employers_challengess.7c0cb479.svg";